import { Component, Output, Input, EventEmitter } from "@angular/core";

@Component({
    selector: "upsell-guarantee",
    templateUrl: "upsell-guarantee.html",
    styleUrls: ["upsell-guarantee.scss"],
    standalone: false
})

export class UpsellGuaranteeComponent {

  @Input() buttonYesText: string = `Yes I want this special added to my order`;
  @Input() buttonNoText: string = `No thanks, I understand that I won't see this offer again`;
  @Input() description: string = '';
  @Input() image: string = '';
  @Input() imageAlt: string = '';
  @Input() showImage: boolean = true;
  @Input() upsellCtaTextButtonsClass: string;

  //Provide external method to navigate to next page over funnel
  @Output() eventEmitter: EventEmitter<boolean> = new EventEmitter();

  buttonValue: boolean = false;

  constructor() {}

  nextPage(buttonValue: boolean) {
    this.buttonValue = buttonValue ? true : false;
    this.eventEmitter.emit(this.buttonValue);
  }
}
